import { Callout, Card, Classes, Colors, Divider, Icon, Intent } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import CX from 'classnames'
import * as React from 'react'
import { ElementJoiner } from '../../../../../../components/ElementJoiner'
import { UprightStyle } from '../../../../../../types'
import { humanReadableErrors } from '../../../../../../utils'
import { hexToRGBA, rgbaForIntent } from '../../../../../../utils/color'
import '../../style.scss'
import { ProjectedStep } from '../../types'
import { ChannelCard } from '../ChannelCard'
import { FutureListingInfo } from '../FutureListingInfo'

interface Props {
  futureSteps: ProjectedStep[]
}
const styles: UprightStyle = {
  arrow: {
    margin: '15px 0'
  },
  currentStepCallout: {
    paddingBottom: 15
  },
  channelName: {
    marginBottom: 4
  },
  hideStepsBtn: {
    margin: '10px 0'
  },
  spaceBetween: {
    justifyContent: 'space-between'
  },
  stepCard: {
    padding: 10,
    textAlign: 'left'
  },
  futureSteps: {
    background: hexToRGBA(Colors.GRAY3, 0.15),
    padding: '14px 12px 0 12px',
    border: `4px solid ${rgbaForIntent(Intent.PRIMARY, 0.15)}`,
    borderBottom: null,
    borderRadius: '5px 5px 0 0',
    width: '97%',
    margin: '0 auto'
  },
  pastListings: {
    background: hexToRGBA(Colors.GRAY3, 0.15),
    padding: '0 12px 14px 12px',
    border: `4px solid ${rgbaForIntent(Intent.PRIMARY, 0.15)}`,
    borderTop: null,
    borderRadius: '0 0 5px 5px',
    width: '97%',
    margin: '0 auto'
  },
  channelCards: {
    textAlign: 'center'
  }
}

export const FutureStepSection: React.FC<Props> = props => {
  return (
    <div style={styles.futureSteps} className={CX('step-section')}>
      {props.futureSteps?.map(step => (
        <>
          <div className="projected-step">
            <Card style={styles.stepCard}>
              <div style={styles.currentStepCallout}>
                <Callout intent={Intent.NONE} title={`Step ${step.step.rank + 1}`} />
                {step.errors && (
                  <Callout intent={Intent.DANGER} title="Please correct the following:">
                    {humanReadableErrors(step)}
                  </Callout>
                )}
              </div>
              <ElementJoiner separator={<Divider />}>
                {step.listings.map(listing => (
                  <ChannelCard channelId={listing.marketId} key={`listing-${listing.listingId}`}>
                    <div>
                      {listing.listingErrors && (
                        <Callout intent={Intent.DANGER} title="Listing error" className="listing-error">
                          {humanReadableErrors({ errors: listing.listingErrors })}
                        </Callout>
                      )}
                      <FutureListingInfo listing={listing} />
                    </div>
                  </ChannelCard>
                ))}
              </ElementJoiner>
            </Card>
          </div>
          {step.errors && (
            <Icon icon={IconNames.CROSS} style={styles.arrow} className={Classes.TEXT_MUTED} intent={Intent.DANGER} />
          )}
          {!step.errors && (
            <Icon icon={IconNames.ARROW_UP} style={styles.arrow} className={Classes.TEXT_MUTED} intent={Intent.NONE} />
          )}
        </>
      ))}
    </div>
  )
}
